import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'next-i18next';

import ReviewOverlay from 'views/common/components/UI/MyReview/ReviewOverlay';

const AddNewReview = (props) => {
  const { reviewOverlayData } = props;
  const { t } = useTranslation('fe_er_my_review');

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        onClick={reviewOverlayData.state.handleOpen}>
        {t('fe_er_my_review:add_review')}
      </Button>

      <ReviewOverlay
        title={t('fe_er_my_review:add_new_review')}
        reviewOverlayData={reviewOverlayData}
      />
    </>
  );
};

export default AddNewReview;
